import React from 'react';
import { FastField, Field, type FieldProps } from 'formik';
import KoobInputTextarea from '../KoobInputTextarea';
import KoobInputLabel from '../KoobInputLabel';

type KoobInputTextareaFieldProps = {
  name: string;
  label?: React.ReactNode;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  minRows?: number;
  maxRows?: number;
  size?: 'sm' | 'md';
  /** Show the error before the field is touched when false */
  touchRequired?: boolean;
  /** Use formik FastField (skips re-renders of untouched fields) */
  fast?: boolean;
  'data-testid'?: string;
};

export const KoobInputTextareaField = ({
  name,
  label,
  required,
  touchRequired = true,
  fast = false,
  ...props
}: KoobInputTextareaFieldProps) => {
  const FieldComponent = fast ? FastField : Field;

  return (
    <FieldComponent name={name}>
      {({ field, meta }: FieldProps) => {
        const hasError = touchRequired
          ? Boolean(meta.error && meta.touched)
          : Boolean(meta.error);

        const textarea = (
          <KoobInputTextarea {...field} {...props} error={hasError} />
        );

        return (
          <div className="flex w-full flex-col gap-1">
            {label != null ? (
              <KoobInputLabel
                label={label}
                required={required}
                disabled={props.disabled}
              >
                {textarea}
              </KoobInputLabel>
            ) : (
              textarea
            )}
            {hasError && (
              <p className="m-0 text-sm text-red-500">{meta.error}</p>
            )}
          </div>
        );
      }}
    </FieldComponent>
  );
};

export default KoobInputTextareaField;
